import { type StripeConstructor } from '@stripe/stripe-js'
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    env?: Record<string, string | undefined>
    Stripe?: StripeConstructor
  }
}

const getValue = (name: string) => {
  // todo: handle missing config
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-unnecessary-type-assertion
  return window?.env?.[name]!
}

export const config = {
  environment: getValue('ENVIRONMENT'),
  appVersion: getValue('APP_VERSION'),
  metapicApiUrl: getValue('METAPIC_API_URL'),
  notificationApiUrl: getValue('NOTIFICATION_API_URL'),
  mediaBaseUrl: getValue('MEDIA_BASE_URL'),
  adminAppUrl: getValue('ADMIN_APP_URL'),
  returnUrl: getValue('RETURN_URL'),
  stripeReturnUrl: getValue('STRIPE_RETURN_URL'),
  stripePublicKey: getValue('STRIPE_PUBLISHABLE_KEY'),
  sentryDsn: getValue('ADVERTISER_APP_SENTRY_DSN'),
  unleash: {
    proxyUrl: getValue('UNLEASH_PROXY_URL'),
    clientKey: getValue('ADVERTISER_APP_UNLEASH_CLIENT_KEY'),
  },
  googleClientId: getValue('GOOGLE_CLIENT_ID'),
  googleScope: getValue('GOOGLE_SCOPE'),
  creatorAppUrl: getValue('CREATOR_APP_URL'),
  novuApiUrl: getValue('NOVU_API_URL'),
  novuSocketUrl: getValue('NOVU_SOCKET_URL'),
  novuAppIdentifier: getValue('NOVU_APP_IDENTIFIER'),
  postHogApiKey: getValue('POSTHOG_API_KEY'),
  isPosthogEnabled: getValue('POSTHOG_ENABLED') === 'true',
  oryApiUrl: getValue('ORY_API_URL'),
  identityAppUrl: getValue('IDENTITY_APP_URL'),
  socialMediaApiUrl: getValue('SOCIAL_MEDIA_API_URL'),
  financeApiUrl: getValue('FINANCE_API_URL'),
  myPagePublicUrl: getValue('MY_PAGE_PUBLIC_URL'),
}

export type RuntimeConfig = typeof config
